import type { FetchErrorResult } from "core/entities/APITypes";
import { formatBlockId } from "./formatBlockId";
import type { AzureBlock } from "./shared";

export async function uploadBlock(
  block: AzureBlock,
  accessToken: string,
  abortSignal?: AbortSignal
): Promise<{ ok: true } | FetchErrorResult> {
  try {
    const url = new URL(accessToken);
    url.searchParams.append("blockid", formatBlockId(block.id));
    url.searchParams.append("comp", "block");
    const uploadResponse = await fetch(url, {
      method: "PUT",
      body: block.data,
      signal: abortSignal,
    });
    if (!uploadResponse.ok) {
      const responseErrorText = await uploadResponse.text();
      return {
        ok: false,
        errorType: "ServerError",
        status: uploadResponse.status,
        statusText: uploadResponse.statusText,
        message: responseErrorText,
      };
    }
  } catch (e) {
    if (e instanceof DOMException && e.name === "AbortError") {
      return {
        ok: false,
        errorType: "AbortError",
        message: abortSignal?.reason,
      };
    }
    return {
      ok: false,
      errorType: "NetworkError",
      message: e instanceof Error ? e.message : String(e),
    };
  }
  return { ok: true };
}
